class ProductBuyBar extends HTMLElement {
  constructor() {
    "use strict";
    super();

    let classes = { show: "show" };
    let mainProductForm = document.querySelector(".product-form");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // In view -> Hide bar
            this.classList.remove(classes.show);
          } else if (window.scrollY > 200) {
            // Out of view AND scrolled a little from top -> Show bar
            this.classList.add(classes.show);
          }
        });
      },
      { threshold: 0.25 }
    );

    observer.observe(mainProductForm);

    // This script is loaded in product-template.liquid --> Footer observer after DOM ready
    document.addEventListener("DOMContentLoaded", function () {
      let siteFooter = document.querySelector("footer.footer");
      if (!siteFooter) return;
      observer.observe(siteFooter);
    });
  }
}
customElements.define("product-buy-bar", ProductBuyBar);

class UpsellCard extends HTMLElement {
  constructor() {
    super();
    this.select = this.querySelector('select');
    this.image = this.querySelector('.card-media img');
    this.button = this.querySelector('.product-form__submit');
    this.productLink = this.querySelector('.card-media').getAttribute('href');

    if (this.select) {
      // Set initial shipping class for the selected variant on page load
      const selectedOption = this.select.options[this.select.selectedIndex];
      if (selectedOption) {
        this.updateButton(selectedOption);
        this.updateShippingClass(selectedOption);
      }
      
      this.select.addEventListener('change', (event) => {
        const selectedOption = event.target.options[event.target.selectedIndex];
        const newImgSrc = selectedOption.getAttribute('data-variant-img-src');
        if (newImgSrc) { this.updateImage(newImgSrc) }
        
        // Update button based on whether variant is custom
        this.updateButton(selectedOption);
        
        // Update shipping class if needed
        this.updateShippingClass(selectedOption);
      });
    }
  }

  updateShippingClass(selectedOption) {
    if (!selectedOption) return;
    
    const shippingClass = selectedOption.dataset.shippingClass;
    const form = this.closest('form');
    
    if (!form) return;
    
    // Remove any existing shipping class inputs
    const existingInputs = form.querySelectorAll('input[name^="properties[_Long_Goods]"], input[name^="properties[_Oversized_Goods]"]');
    existingInputs.forEach(input => input.remove());
    
    if (shippingClass) {
      // Add shipping class with dynamic property name
      const shippingClassInput = document.createElement('input');
      shippingClassInput.type = 'hidden';
      shippingClassInput.name = `properties[_${shippingClass}]`;
      shippingClassInput.value = 'Yes';
      form.appendChild(shippingClassInput);
    }
  }

  updateButton(selectedOption) {
    if (!this.button || !this.productLink) return;
    
    const isCustomVariant = selectedOption.dataset.isCustom === 'true';
    
    if (isCustomVariant) {
      // Convert button to link for custom variants
      if (this.button.tagName === 'BUTTON') {
        const linkButton = document.createElement('a');
        linkButton.href = this.productLink;
        linkButton.className = this.button.className;
        linkButton.innerHTML = this.button.innerHTML;
        // Remove spinner for links
        const spinner = linkButton.querySelector('.loading-overlay');
        if (spinner) spinner.remove();
        this.button.replaceWith(linkButton);
        this.button = linkButton;
      } else {
        // Already a link, just update href
        this.button.href = this.productLink;
      }
    } else {
      // Convert link back to button for standard variants
      if (this.button.tagName === 'A') {
        const submitButton = document.createElement('button');
        submitButton.type = 'submit';
        submitButton.name = 'add';
        submitButton.className = this.button.className;
        
        // Get icons and text
        const icons = this.button.querySelectorAll('svg');
        const visuallyHidden = this.button.querySelector('.visually-hidden');
        
        // Build button content
        if (icons[0]) submitButton.appendChild(icons[0].cloneNode(true));
        if (icons[1]) submitButton.appendChild(icons[1].cloneNode(true));
        if (visuallyHidden) submitButton.appendChild(visuallyHidden.cloneNode(true));
        
        // Add spinner back
        const spinner = document.createElement('div');
        spinner.className = 'loading-overlay loading-overlay__spinner hidden';
        spinner.innerHTML = '<svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg>';
        submitButton.appendChild(spinner);
        
        // Check if variant is available
        const isDisabled = selectedOption.disabled;
        if (isDisabled) {
          submitButton.setAttribute('disabled', 'disabled');
        }
        
        this.button.replaceWith(submitButton);
        this.button = submitButton;
      }
    }
  }

  updateImage(newImgSrc) {
    if (this.image && newImgSrc) {
      // Sanitize and validate URL to prevent XSS
      // Remove any whitespace and HTML entities
      const sanitized = String(newImgSrc).trim().replace(/[\s<>"']/g, '');

      // Reject dangerous protocols (check anywhere in string, not just start)
      const dangerousProtocols = /^(javascript|data|vbscript|file|about):/i;
      if (dangerousProtocols.test(sanitized)) {
        return; // Reject dangerous URLs
      }

      try {
        // Try to parse as absolute URL
        const url = new URL(sanitized, window.location.origin);
        // Only allow http and https protocols
        if (url.protocol === 'http:' || url.protocol === 'https:') {
          // Use the properly constructed URL to prevent any encoding issues
          this.image.src = url.href;
        }
      } catch (e) {
        // If URL parsing fails, it's likely a relative URL
        // Additional validation: ensure it doesn't contain dangerous patterns
        if (!sanitized.includes('javascript:') &&
            !sanitized.includes('data:') &&
            !sanitized.includes('vbscript:') &&
            !sanitized.includes('<') &&
            !sanitized.includes('>')) {
          // For relative URLs, ensure proper encoding
          this.image.src = sanitized;
        }
      }
    }
  }
}

customElements.define('upsell-card', UpsellCard);